// ── Shared Styles (earthy orange palette) ───────────────────────────
const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid #7a2e00', fontFamily:"'Georgia', serif", color:'#1a0e06', lineHeight:'1.7', background:'#fdf6ee' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c45a10', paddingBottom:'8px', marginBottom:'24px', color:'#7a2e00' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#a04010', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c45a10', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#fdf0e4', border:'2px solid #c45a10', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7a2e00', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c45a10' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#a04010', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf4ec' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf6ee' },
  tdL:          { fontWeight:'600', color:'#7a2e00', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fdf4ec', border:'1px solid #e8b07a', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7a2e00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#7a4a28', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Detail</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 1 — Lathe Dog System Overview (between-centres setup)
// ─────────────────────────────────────────────────────────────────────
function DiagramLatheSetup() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Lathe Dog (Carrier) System — Between-Centres Turning Setup</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arD1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <marker id="arD1r" markerWidth="7" markerHeight="7" refX="2" refY="3.5" orient="auto">
            <polygon points="6 0,0 3.5,6 7" fill="#c45a10"/>
          </marker>
        </defs>

        {/* ── Lathe bed (two rails) ── */}
        <rect x={10}  y={250} width={880} height={14} rx={3} fill="#c45a10" opacity="0.25" stroke="#7a2e00" strokeWidth="1.5"/>
        <rect x={10}  y={272} width={880} height={14} rx={3} fill="#c45a10" opacity="0.25" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={450} y={298} textAnchor="middle" fontSize="9" fill="#7a4a28" fontStyle="italic">Lathe bed / ways</text>

        {/* ── Headstock spindle ── */}
        <rect x={10} y={140} width={95} height={110} rx={6} fill="#d4874a" opacity="0.8" stroke="#7a2e00" strokeWidth="2"/>
        <text x={57}  y={188} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Head-</text>
        <text x={57}  y={201} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">stock</text>
        {/* Spindle nose */}
        <rect x={105} y={183} width={22} height={30} rx={3} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* ── Drive / Face plate ── */}
        <circle cx={158} cy={198} r={38} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={158} cy={198} r={10} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={158} y={176} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fdf4ec">Drive</text>
        <text x={158} y={187} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fdf4ec">Plate</text>
        {/* Drive pin on faceplate */}
        <circle cx={178} cy={172} r={6} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1.5"/>
        <text x={185} y={162} fontSize="8" fill="#7a2e00" fontWeight="700">Drive pin</text>

        {/* ── Rotation arrow on faceplate ── */}
        <path d="M 130 165 A 34 34 0 0 1 192 165" fill="none" stroke="#c45a10" strokeWidth="2" markerEnd="url(#arD1)"/>
        <text x={158} y={152} textAnchor="middle" fontSize="9" fontWeight="700" fill="#c45a10">ω (CW)</text>

        {/* ── Workpiece (long shaft between centres) ── */}
        <rect x={190} y={186} width={490} height={24} rx={4} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="2"/>
        <text x={435} y={202} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Workpiece (shaft / round bar)</text>

        {/* ── Live centre (headstock end) ── */}
        <polygon points="190,186 190,210 207,198" fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={165} y={232} textAnchor="middle" fontSize="8" fill="#7a4a28">Live centre</text>

        {/* ── Dead / tailstock centre ── */}
        <polygon points="680,186 680,210 663,198" fill="#7a2e00" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={710} y={232} textAnchor="middle" fontSize="8" fill="#7a4a28">Dead centre</text>

        {/* ── Tailstock body ── */}
        <rect x={680} y={148} width={80} height={102} rx={5} fill="#d4874a" opacity="0.65" stroke="#7a2e00" strokeWidth="2"/>
        <text x={720} y={197} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Tail-</text>
        <text x={720} y={210} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">stock</text>

        {/* ── Lathe Dog (bent-tail type) ── */}
        {/* Body of dog — clamped onto workpiece near headstock */}
        <rect x={218} y={177} width={52} height={42} rx={5} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1.5"/>
        <text x={244} y={195} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Lathe</text>
        <text x={244} y={206} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Dog</text>
        {/* Set-screw on top of dog */}
        <rect x={232} y={172} width={12} height={8} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="1"/>
        <text x={238} y={170} textAnchor="middle" fontSize="7" fill="#7a2e00">↓ set-screw</text>
        {/* Bent tail extending up to drive pin */}
        <path d="M 257 177 L 257 155 L 178 155" fill="none" stroke="#7a2e00" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
        <text x={215} y={148} textAnchor="middle" fontSize="8" fill="#7a2e00" fontWeight="700">Bent tail</text>
        {/* Tail engages drive pin circle */}
        <circle cx={178} cy={155} r={7} fill="none" stroke="#c45a10" strokeWidth="2" strokeDasharray="3,2"/>

        {/* ── Annotation arrows ── */}
        {/* Drive pin → tail engagement */}
        <line x1={180} y1={165} x2={180} y2={150} stroke="#c45a10" strokeWidth="1.5" markerEnd="url(#arD1)"/>
        <text x={132} y={140} textAnchor="middle" fontSize="8" fill="#c45a10">Pin drives</text>
        <text x={132} y={151} textAnchor="middle" fontSize="8" fill="#c45a10">tail → torque</text>

        {/* Dog body label */}
        <line x1={244} y1={220} x2={244} y2={238} stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={244} y={248} textAnchor="middle" fontSize="8" fill="#7a4a28">Dog clamped on</text>
        <text x={244} y={259} textAnchor="middle" fontSize="8" fill="#7a4a28">workpiece by set-screw</text>

        {/* ── Cutting tool indicator ── */}
        <rect x={370} y={160} width={32} height={28} rx={3} fill="#a04010" opacity="0.7" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={386} y={175} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fff">Tool</text>
        <line x1={386} y1={188} x2={386} y2={186} stroke="#7a2e00" strokeWidth="2"/>
        {/* Feed arrow */}
        <line x1={380} y1={155} x2={340} y2={155} stroke="#c45a10" strokeWidth="1.5" markerEnd="url(#arD1r)"/>
        <text x={358} y={149} textAnchor="middle" fontSize="8" fill="#c45a10">Feed →</text>

        {/* ── Info callout panel ── */}
        <rect x={765} y={20} width={125} height={220} rx={5} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={827} y={37} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">How it works</text>
        <line x1={773} y1={42} x2={882} y2={42} stroke="#e8b07a"/>
        {[
          '1. Mount drive plate',
          '   on headstock spindle',
          '2. Support workpiece',
          '   between centres',
          '3. Clamp dog onto',
          '   workpiece end',
          '4. Hook dog tail over',
          '   faceplate drive pin',
          '5. Spindle rotates →',
          '   pin pushes tail →',
          '   dog drives work',
          '6. Centre supports',
          '   both ends precisely',
        ].map((line, i) => (
          <text key={i} x={773} y={55 + i * 14} fontSize="8" fill={i===8||i===9||i===10?'#c45a10':'#a04010'}
            fontWeight={i===8||i===9||i===10?'700':'400'}>{line}</text>
        ))}

        {/* ── Key advantage annotation ── */}
        <rect x={10} y={310} width={740} height={24} rx={4} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={375} y={322} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">
          Key advantage: workpiece supported at BOTH ends between centres → highest possible concentricity &amp; repeatability
        </text>
        <text x={375} y={330} textAnchor="middle" fontSize="8" fill="#7a4a28">
          Removing and re-mounting the workpiece returns it to the same axis — essential for multi-operation precision shafts
        </text>
      </svg>
      <div style={S.dCaption}>The lathe dog transmits rotary motion from the spindle to the workpiece without touching the centres — centres provide only location, not drive</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 2 — Lathe Dog Types (straight-tail, bent-tail, clamp dog)
// ─────────────────────────────────────────────────────────────────────
function DiagramDogTypes() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Lathe Dog Types — Straight-Tail, Bent-Tail &amp; Clamp Dog</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* ── STRAIGHT TAIL DOG ── left panel */}
        <rect x={10} y={10} width={270} height={300} rx={6} fill="none" stroke="#e8b07a" strokeDasharray="5,3" strokeWidth="1.5"/>
        <text x={145} y={28} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Straight-Tail Dog</text>

        {/* Dog body */}
        <rect x={60} y={55} width={80} height={55} rx={6} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        {/* V-groove inside body */}
        <path d="M 70 72 L 100 90 L 130 72" fill="none" stroke="#fdf4ec" strokeWidth="2"/>
        <text x={100} y={88} textAnchor="middle" fontSize="8" fill="#fdf4ec">V-groove</text>
        {/* Set-screw */}
        <rect x={92} y={48} width={14} height={10} rx={2} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1"/>
        <text x={99} y={57} textAnchor="middle" fontSize="7" fill="#fdf4ec">↑</text>
        <text x={99} y={46} textAnchor="middle" fontSize="7" fill="#7a2e00">set-screw</text>
        {/* Straight tail */}
        <rect x={135} y={68} width={70} height={14} rx={3} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={170} y={79} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Straight tail</text>
        {/* Drive pin (stud on faceplate) it catches */}
        <circle cx={220} cy={75} r={8} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1.5"/>
        <text x={220} y={96} textAnchor="middle" fontSize="8" fill="#7a2e00">Drive pin</text>
        {/* Workpiece stub */}
        <rect x={60} y={78} width={35} height={18} rx={3} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={77} y={91} textAnchor="middle" fontSize="8" fill="#7a2e00">Work</text>

        <text x={145} y={128} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Characteristics</text>
        {[
          '• Tail exits radially (straight)',
          '• Requires drive stud/pin',
          '  on faceplate',
          '• No risk of crowding',
          '  workpiece off-centre',
          '• Better balance than bent',
          '• Used for round &',
          '  cylindrical workpieces',
          '• Preferred for precision work',
        ].map((l, i) => (
          <text key={i} x={20} y={142 + i * 14} fontSize="8.5" fill="#a04010">{l}</text>
        ))}

        {/* ── BENT TAIL DOG ── centre panel */}
        <rect x={310} y={10} width={270} height={300} rx={6} fill="none" stroke="#e8b07a" strokeDasharray="5,3" strokeWidth="1.5"/>
        <text x={445} y={28} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Bent-Tail Dog</text>

        {/* Dog body */}
        <rect x={360} y={55} width={80} height={55} rx={6} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <path d="M 370 72 L 400 90 L 430 72" fill="none" stroke="#fdf4ec" strokeWidth="2"/>
        <rect x={390} y={48} width={14} height={10} rx={2} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1"/>
        {/* Bent tail — goes up then bends */}
        <path d="M 392 55 L 392 35 L 445 35" fill="none" stroke="#a04010" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
        <text x={420} y={26} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Bent tail</text>
        {/* Faceplate slot it engages */}
        <rect x={445} y={28} width={24} height={16} rx={2} fill="#7a2e00" opacity="0.8" stroke="#fdf4ec" strokeWidth="1.5"/>
        <text x={457} y={54} textAnchor="middle" fontSize="8" fill="#7a2e00">slot</text>
        <text x={360} y={128} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Workpiece</text>
        <rect x={315} y={78} width={45} height={18} rx={3} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={337} y={91} textAnchor="middle" fontSize="8" fill="#7a2e00">Work</text>

        <text x={445} y={128} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Characteristics</text>
        {[
          '• Tail bends 90° — fits',
          '  into faceplate slot or',
          '  catches chuck jaw',
          '• More compact than',
          '  straight tail',
          '• Risk: tail can wedge in',
          '  closed-end slot →',
          '  crowds work off-centre',
          '• Common for quick',
          '  setup work',
        ].map((l, i) => (
          <text key={i} x={318} y={142 + i * 14} fontSize="8.5" fill="#a04010">{l}</text>
        ))}

        {/* ── CLAMP DOG ── right panel */}
        <rect x={610} y={10} width={280} height={300} rx={6} fill="none" stroke="#e8b07a" strokeDasharray="5,3" strokeWidth="1.5"/>
        <text x={750} y={28} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Clamp Dog</text>

        {/* Body lower half */}
        <rect x={660} y={80} width={110} height={35} rx={4} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        {/* Body upper half (moveable clamp) */}
        <rect x={660} y={55} width={110} height={28} rx={4} fill="#d4874a" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <text x={715} y={47} textAnchor="middle" fontSize="8" fill="#7a2e00">Moveable clamp</text>
        {/* Cap screws */}
        <circle cx={680} cy={68} r={5} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1"/>
        <circle cx={750} cy={68} r={5} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1"/>
        <text x={715} y={68} textAnchor="middle" fontSize="7" fill="#7a2e00">cap screws</text>
        {/* Irregular workpiece (square) */}
        <rect x={685} y={84} width={28} height={22} rx={1} fill="#d4874a" opacity="0.6" stroke="#7a2e00" strokeWidth="2"/>
        <text x={699} y={97} textAnchor="middle" fontSize="7" fill="#7a2e00">sqr</text>
        <text x={699} y={105} textAnchor="middle" fontSize="7" fill="#7a2e00">work</text>

        {/* Tail on clamp dog */}
        <rect x={770} y={90} width={55} height={12} rx={3} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={797} y={100} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">tail</text>

        <text x={750} y={138} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Characteristics</text>
        {[
          '• Two-piece body with two',
          '  cap screws → universal',
          '  clamping of any shape',
          '• Holds square, hex, flat,',
          '  or irregular sections',
          '• Slower to set up',
          '  than screw types',
          '• Used when standard',
          '  dogs cannot grip',
          '• Adjustable jaw width',
        ].map((l, i) => (
          <text key={i} x={618} y={152 + i * 14} fontSize="8.5" fill="#a04010">{l}</text>
        ))}

        {/* Comparison footer */}
        <rect x={10} y={318} width={880} height={16} rx={3} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={450} y={329} textAnchor="middle" fontSize="8.5" fontWeight="700" fill="#7a2e00">
          Single-screw dogs: fast, for round stock · Double-screw dogs: better balance for large diameters · Clamp dogs: for non-round workpieces
        </text>
      </svg>
      <div style={S.dCaption}>All lathe dog types transmit torque by mechanical engagement — the set-screw clamps the dog to the workpiece; the tail transmits spindle rotation</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 3 — Dog Clutch Anatomy (exploded + engaged view)
// ─────────────────────────────────────────────────────────────────────
function DiagramDogClutchAnatomy() {
  const W = 900, H = 360;

  // Helper — draw a dog ring (face view) with N rectangular teeth
  const DogRing = ({ cx, cy, ro, ri, nTeeth, fill, stroke, angle=0 }) => {
    const pts = [];
    const tw = (2 * Math.PI / nTeeth) * 0.52; // tooth angular width (52% of pitch)
    for (let i = 0; i < nTeeth; i++) {
      const a0 = angle + (2 * Math.PI * i) / nTeeth;
      const a1 = a0 + tw;
      pts.push(
        `M ${(cx + ri*Math.cos(a0)).toFixed(1)} ${(cy + ri*Math.sin(a0)).toFixed(1)}`,
        `L ${(cx + ro*Math.cos(a0)).toFixed(1)} ${(cy + ro*Math.sin(a0)).toFixed(1)}`,
        `A ${ro} ${ro} 0 0 1 ${(cx + ro*Math.cos(a1)).toFixed(1)} ${(cy + ro*Math.sin(a1)).toFixed(1)}`,
        `L ${(cx + ri*Math.cos(a1)).toFixed(1)} ${(cy + ri*Math.sin(a1)).toFixed(1)}`,
        `A ${ri} ${ri} 0 0 0 ${(cx + ri*Math.cos(a0)).toFixed(1)} ${(cy + ri*Math.sin(a0)).toFixed(1)} Z`
      );
    }
    return (
      <g>
        <circle cx={cx} cy={cy} r={ro} fill="#fdf4ec" stroke={stroke} strokeWidth="1.5"/>
        <path d={pts.join(' ')} fill={fill} stroke={stroke} strokeWidth="1.5"/>
        <circle cx={cx} cy={cy} r={ri*0.55} fill={fill} stroke={stroke} strokeWidth="1.5" opacity="0.4"/>
        <circle cx={cx} cy={cy} r={ri*0.22} fill="#fdf4ec" stroke={stroke} strokeWidth="1.5"/>
      </g>
    );
  };

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Dog Clutch — Anatomy, Engagement Sequence &amp; Tooth Profiles</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arDC" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
        </defs>

        {/* ══ LEFT: SIDE-VIEW CROSS-SECTION of dog clutch ══ */}
        <text x={195} y={18} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Side View — Disengaged &amp; Engaged</text>

        {/* SHAFT 1 (left) — input */}
        <rect x={10} y={148} width={110} height={28} rx={3} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/>
        <text x={65} y={166} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Input Shaft</text>
        {/* Spline lines on shaft */}
        {[158,163,168,173].map((y,i)=>(
          <line key={i} x1={10} y1={y} x2={120} y2={y} stroke="#7a2e00" strokeWidth="0.8" opacity="0.4"/>
        ))}

        {/* SHAFT 2 (right) — output, freewheeling gear hub */}
        <rect x={310} y={148} width={110} height={28} rx={3} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/>
        <text x={365} y={166} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Output Shaft</text>
        {/* Gear on output shaft (freewheels unless dog engaged) */}
        <rect x={298} y={130} width={40} height={64} rx={4} fill="#e8b07a" stroke="#7a2e00" strokeWidth="2"/>
        <text x={318} y={158} textAnchor="middle" fontSize="8" fill="#7a2e00">Gear</text>
        <text x={318} y={170} textAnchor="middle" fontSize="8" fill="#7a2e00">(free)</text>

        {/* DOG RING / SLIDING SLEEVE — on input shaft splines */}
        {/* DISENGAGED position (above) */}
        <rect x={115} y={132} width={68} height={60} rx={5} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2.5"/>
        <text x={149} y={155} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Dog</text>
        <text x={149} y={166} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Ring</text>
        {/* Dog teeth on right face (protruding) */}
        {[138, 150, 162, 174].map((y, i) => (
          <rect key={i} x={183} y={y} width={16} height={8} rx={1} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="1"/>
        ))}
        {/* Dog teeth on gear left face (recesses) */}
        {[138, 150, 162, 174].map((y, i) => (
          <rect key={i} x={295} y={y} width={10} height={8} rx={1} fill="#a04010" opacity="0.7" stroke="#7a2e00" strokeWidth="1"/>
        ))}

        {/* Gap / clearance annotation */}
        <line x1={199} y1={162} x2={295} y2={162} stroke="#c45a10" strokeWidth="1.5" strokeDasharray="4,2"/>
        <text x={247} y={155} textAnchor="middle" fontSize="8" fontWeight="700" fill="#c45a10">Gap = DISENGAGED</text>

        {/* Shift fork groove on dog ring */}
        <rect x={133} y={128} width={32} height={8} rx={2} fill="#7a2e00" opacity="0.6"/>
        <text x={149} y={122} textAnchor="middle" fontSize="8" fill="#7a2e00">fork groove</text>
        <line x1={149} y1={128} x2={149} y2={123} stroke="#7a2e00" strokeWidth="1"/>

        {/* Shift arrow (axial movement) */}
        <line x1={149} y1={108} x2={220} y2={108} stroke="#c45a10" strokeWidth="2" markerEnd="url(#arDC)"/>
        <text x={180} y={103} textAnchor="middle" fontSize="9" fontWeight="700" fill="#c45a10">axial shift → ENGAGE</text>

        {/* ENGAGED label */}
        <rect x={200} y={185} width={90} height={22} rx={3} fill="#7a2e00" opacity="0.85"/>
        <text x={245} y={200} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fdf4ec">ENGAGED: teeth mesh</text>

        {/* ══ MIDDLE: Face view comparison ══ */}
        <line x1={430} y1={10} x2={430} y2={355} stroke="#e8c89a" strokeWidth="1" strokeDasharray="5,3"/>
        <text x={570} y={18} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Face View — Dog Ring Teeth</text>

        {/* Dog ring face — RECTANGULAR teeth */}
        <DogRing cx={510} cy={110} ro={68} ri={42} nTeeth={6} fill="#c45a10" stroke="#7a2e00"/>
        <text x={510} y={192} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Rectangular Teeth</text>
        <text x={510} y={205} textAnchor="middle" fontSize="8.5" fill="#7a4a28">Square profile — high strength</text>
        <text x={510} y={217} textAnchor="middle" fontSize="8.5" fill="#7a4a28">Needs speed-match to engage</text>
        <text x={510} y={229} textAnchor="middle" fontSize="8.5" fill="#7a4a28">Used: motorsport, racing boxes</text>

        {/* Dog ring face — CHAMFERED / trapezoidal teeth */}
        <DogRing cx={680} cy={110} ro={68} ri={42} nTeeth={6} fill="#d4874a" stroke="#7a2e00" angle={0.15}/>
        {/* Chamfer indication arrows */}
        {[0,1,2,3,4,5].map(i => {
          const a = 0.15 + (2*Math.PI*i)/6;
          const aw = (2*Math.PI/6)*0.52;
          const am = a + aw;
          const rm = 72;
          return (
            <circle key={i}
              cx={680 + rm*Math.cos(am)} cy={110 + rm*Math.sin(am)}
              r={3} fill="#7a2e00" opacity="0.6"/>
          );
        })}
        <text x={680} y={192} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Chamfered / Tapered Teeth</text>
        <text x={680} y={205} textAnchor="middle" fontSize="8.5" fill="#7a4a28">Lead-in chamfer aids engagement</text>
        <text x={680} y={217} textAnchor="middle" fontSize="8.5" fill="#7a4a28">Allows slight speed mismatch</text>
        <text x={680} y={229} textAnchor="middle" fontSize="8.5" fill="#7a4a28">Used: automotive gearboxes</text>

        {/* ══ BOTTOM: Tooth profiles cross-section comparison ══ */}
        <rect x={435} y={248} width={450} height={100} rx={5} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={660} y={265} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Tooth Profile Cross-Sections</text>
        <line x1={443} y1={270} x2={877} y2={270} stroke="#e8b07a"/>

        {/* Rectangular */}
        <rect x={460} y={280} width={30} height={40} rx={1} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <rect x={498} y={280} width={30} height={40} rx={1} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <text x={494} y={332} textAnchor="middle" fontSize="8.5" fill="#7a2e00">Rectangular</text>
        <text x={494} y={342} textAnchor="middle" fontSize="8" fill="#7a4a28">Max strength, no self-eject</text>

        {/* Trapezoidal */}
        <polygon points="570,320 580,280 608,280 618,320" fill="#d4874a" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <polygon points="626,320 636,280 664,280 674,320" fill="#d4874a" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <text x={622} y={332} textAnchor="middle" fontSize="8.5" fill="#7a2e00">Trapezoidal</text>
        <text x={622} y={342} textAnchor="middle" fontSize="8" fill="#7a4a28">Chamfered for easier engage</text>

        {/* Pent-roof */}
        <polygon points="700,320 710,280 724,270 738,280 748,320" fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <polygon points="755,320 765,280 779,270 793,280 803,320" fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
        <text x={751} y={332} textAnchor="middle" fontSize="8.5" fill="#7a2e00">Pent-Roof</text>
        <text x={751} y={342} textAnchor="middle" fontSize="8" fill="#7a4a28">Self-centering, low mis-shift wear</text>

        {/* Bottom notes */}
        <text x={450} y={353} fontSize="8" fill="#7a4a28">Typical: 6–12 dogs per ring  ·  Fewer dogs = larger windows = easier to catch but more shock load per tooth</text>
      </svg>
      <div style={S.dCaption}>Dog clutch operates as a binary on/off coupling — once engaged, zero slip occurs · tooth profile selection trades off ease of engagement against strength</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 4 — Synchromesh engagement sequence
// ─────────────────────────────────────────────────────────────────────
function DiagramSynchromesh() {
  const W = 900, H = 310;

  const phases = [
    { x: 55,  label: '① Neutral',         desc: 'Sleeve centred\nDog ring free\nGear freewheels' },
    { x: 235, label: '② Pre-synchro',      desc: 'Struts push\nblocker ring\nonto cone' },
    { x: 415, label: '③ Synchro',          desc: 'Friction cone\nmatches speeds\nBlocker held out' },
    { x: 595, label: '④ Speed matched',    desc: 'Speeds equal\nblocker rotates\nfree to pass' },
    { x: 775, label: '⑤ Dog engaged',      desc: 'Sleeve dogs\nmesh with gear\ndogs — locked' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Synchromesh Engagement Sequence — Five Phases from Neutral to Locked</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arSY" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#a04010"/>
          </marker>
        </defs>

        {/* Phase flow arrows */}
        {[155, 335, 515, 695].map((x, i) => (
          <line key={i} x1={x} y1={155} x2={x+60} y2={155} stroke="#a04010" strokeWidth="2" markerEnd="url(#arSY)"/>
        ))}

        {phases.map((ph, pi) => {
          const cy = 155;
          const isLast = pi === 4;
          const isFirst = pi === 0;

          return (
            <g key={pi}>
              {/* Phase box background */}
              <rect x={ph.x - 70} y={40} width={140} height={230} rx={6}
                fill={isLast ? '#fdf0e4' : '#fdf4ec'} stroke={isLast ? '#c45a10' : '#e8b07a'}
                strokeWidth={isLast ? 2.5 : 1.5}/>
              <text x={ph.x} y={58} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#7a2e00">{ph.label}</text>
              <line x1={ph.x-65} y1={63} x2={ph.x+65} y2={63} stroke="#e8b07a"/>

              {/* Shaft (horizontal line) */}
              <line x1={ph.x-65} y1={cy} x2={ph.x+65} y2={cy} stroke="#7a2e00" strokeWidth="4"/>

              {/* Gear (circle, right side) */}
              <circle cx={ph.x+38} cy={cy} r={28}
                fill={isLast ? '#c45a10' : '#e8b07a'} opacity="0.7"
                stroke="#7a2e00" strokeWidth="2"/>
              <text x={ph.x+38} y={cy+4} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">gear</text>

              {/* Cone (friction element) between sleeve and gear */}
              {pi >= 1 && (
                <polygon
                  points={`${ph.x+4},${cy-14} ${ph.x+22},${cy-22} ${ph.x+22},${cy+22} ${ph.x+4},${cy+14}`}
                  fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5" opacity={pi >= 2 ? 0.9 : 0.5}/>
              )}
              {pi >= 2 && (
                <text x={ph.x+16} y={cy-24} textAnchor="middle" fontSize="7" fill="#a04010">friction</text>
              )}

              {/* Blocker ring */}
              {(pi === 1 || pi === 2 || pi === 3) && (
                <rect x={ph.x-8} y={cy-20} width={10} height={40} rx={2}
                  fill={pi===3?'#e8b07a':'#7a2e00'} stroke="#7a2e00" strokeWidth="1.5" opacity="0.85"/>
              )}
              {(pi === 1 || pi === 2) && (
                <text x={ph.x-2} y={cy-24} textAnchor="middle" fontSize="7" fill="#7a2e00">block</text>
              )}

              {/* Sliding sleeve */}
              <rect
                x={pi === 0 ? ph.x-30 : pi === 1 ? ph.x-20 : pi === 2 ? ph.x-12 : pi === 3 ? ph.x-6 : ph.x+2}
                y={cy-18} width={26} height={36} rx={3}
                fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
              <text x={(pi === 0 ? ph.x-30 : pi === 1 ? ph.x-20 : pi === 2 ? ph.x-12 : pi === 3 ? ph.x-6 : ph.x+2)+13}
                y={cy+4} textAnchor="middle" fontSize="7" fontWeight="700" fill="#fdf4ec">sleeve</text>

              {/* Dog teeth visible on sleeve (last phase) */}
              {isLast && [cy-14, cy-6, cy+2, cy+10].map((ty, j) => (
                <rect key={j} x={ph.x+26} y={ty} width={10} height={6} rx={1} fill="#7a2e00" opacity="0.8"/>
              ))}
              {/* Dog teeth on gear (last phase) */}
              {isLast && [cy-14, cy-6, cy+2, cy+10].map((ty, j) => (
                <rect key={j} x={ph.x+8} y={ty} width={8} height={6} rx={1} fill="#7a2e00" opacity="0.8"/>
              ))}

              {/* Speed annotations */}
              <text x={ph.x-42} y={cy-28} textAnchor="middle" fontSize="7" fill="#c45a10">ω_shaft</text>
              <text x={ph.x+38} y={cy-32} textAnchor="middle" fontSize="7"
                fill={isLast||pi===3?'#c45a10':'#a04010'}>ω_gear</text>
              {pi >= 3 && (
                <text x={ph.x} y={cy-38} textAnchor="middle" fontSize="8" fontWeight="700" fill={isLast?'#7a2e00':'#c45a10'}>
                  {isLast ? '✓ LOCK' : 'speeds ='}
                </text>
              )}

              {/* Description text */}
              {ph.desc.split('\n').map((line, li) => (
                <text key={li} x={ph.x} y={220 + li*14} textAnchor="middle" fontSize="8.5" fill="#a04010">{line}</text>
              ))}
            </g>
          );
        })}

        {/* Force/time diagram at bottom */}
        <rect x={10} y={280} width={880} height={24} rx={4} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={450} y={293} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">
          Synchro cone friction torque: T_sync = μ × F_axial × R_cone / sin(α_cone)  ·  Cone half-angle α typically 6–7° ·  Time to sync: t ≈ J×Δω / T_sync
        </text>
        <text x={450} y={302} textAnchor="middle" fontSize="8" fill="#7a4a28">
          (J = moment of inertia of synchronising mass, Δω = speed difference, T_sync = synchronising torque)
        </text>
      </svg>
      <div style={S.dCaption}>Synchromesh prevents dog tooth clash by using a friction cone to equalise speeds before the positive dog teeth are allowed to engage</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 5 — Dog Clutch in Constant-Mesh Gearbox
// ─────────────────────────────────────────────────────────────────────
function DiagramGearbox() {
  const W = 900, H = 320;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Dog Clutch in a Constant-Mesh Manual Gearbox — 3-Speed Layout</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arGB" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
        </defs>

        {/* ── INPUT SHAFT (top) ── */}
        <rect x={10} y={78} width={880} height={20} rx={3} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="2"/>
        <text x={20} y={72} fontSize="10" fontWeight="700" fill="#7a2e00">Input shaft (from engine/clutch)</text>

        {/* Input shaft gears — fixed to shaft, always rotate with it */}
        {[
          { x: 100, r: 32, t: '1st\nz=40', lbl: 'G1A' },
          { x: 330, r: 26, t: '2nd\nz=30', lbl: 'G2A' },
          { x: 560, r: 22, t: '3rd\nz=22', lbl: 'G3A' },
          { x: 760, r: 18, t: '4th\nz=16', lbl: 'G4A' },
        ].map((g, i) => (
          <g key={i}>
            {/* Gear rim */}
            <circle cx={g.x} cy={88} r={g.r} fill="#c45a10" opacity="0.75" stroke="#7a2e00" strokeWidth="2"/>
            <text x={g.x} y={82} textAnchor="middle" fontSize="7" fontWeight="700" fill="#fdf4ec">{g.t.split('\n')[0]}</text>
            <text x={g.x} y={91} textAnchor="middle" fontSize="7" fill="#fdf4ec">{g.t.split('\n')[1]}</text>
            <text x={g.x} y={57} textAnchor="middle" fontSize="7.5" fill="#7a2e00">Fixed to shaft</text>
          </g>
        ))}

        {/* ── OUTPUT SHAFT (bottom) ── */}
        <rect x={10} y={210} width={880} height={20} rx={3} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="2"/>
        <text x={20} y={250} fontSize="10" fontWeight="700" fill="#7a2e00">Output shaft (to propshaft / wheels)</text>

        {/* Output shaft gears — FREEWHEEL on shaft unless dog engaged */}
        {[
          { x: 100, r: 44, t: '1st\nz=56', engaged: false },
          { x: 330, r: 36, t: '2nd\nz=44', engaged: true },
          { x: 560, r: 28, t: '3rd\nz=34', engaged: false },
          { x: 760, r: 22, t: '4th\nz=24', engaged: false },
        ].map((g, i) => (
          <g key={i}>
            <circle cx={g.x} cy={210} r={g.r}
              fill={g.engaged ? '#c45a10' : '#e8b07a'}
              opacity={g.engaged ? 0.85 : 0.5}
              stroke="#7a2e00" strokeWidth={g.engaged ? 2.5 : 1.5}/>
            <text x={g.x} y={205} textAnchor="middle" fontSize="7" fontWeight="700"
              fill={g.engaged ? '#fdf4ec' : '#7a4a28'}>{g.t.split('\n')[0]}</text>
            <text x={g.x} y={214} textAnchor="middle" fontSize="7"
              fill={g.engaged ? '#fdf4ec' : '#7a4a28'}>{g.t.split('\n')[1]}</text>
            <text x={g.x} y={264} textAnchor="middle" fontSize="7.5"
              fill={g.engaged ? '#c45a10' : '#7a4a28'}
              fontWeight={g.engaged ? '700' : '400'}>
              {g.engaged ? 'ENGAGED ↑' : 'Freewheels'}
            </text>
          </g>
        ))}

        {/* Mesh lines between shafts */}
        {[100, 330, 560, 760].map((x, i) => (
          <line key={i} x1={x} y1={120} x2={x} y2={166} stroke="#7a2e00" strokeWidth="1.5" strokeDasharray="3,2" opacity="0.5"/>
        ))}

        {/* DOG RINGS on output shaft (splined, can slide) */}
        {/* Dog ring 1-2 (between gears 1 and 2 on output) */}
        <rect x={185} y={193} width={100} height={36} rx={4}
          fill="#7a2e00" opacity="0.85" stroke="#fdf4ec" strokeWidth="1.5"/>
        <text x={235} y={209} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Dog Ring</text>
        <text x={235} y={220} textAnchor="middle" fontSize="7" fill="#fdf4ec">1st–2nd selector</text>
        {/* Dog teeth — pointing left (toward 1st gear) and right (toward 2nd) */}
        {[196,204,212,220].map((y,i)=>(
          <g key={i}>
            <rect x={173} y={y} width={14} height={6} rx={1} fill="#c45a10" stroke="#fdf4ec" strokeWidth="0.8"/>
            <rect x={285} y={y} width={14} height={6} rx={1} fill="#c45a10" stroke="#fdf4ec" strokeWidth="0.8"/>
          </g>
        ))}
        {/* Shift fork groove */}
        <rect x={218} y={188} width={34} height={8} rx={2} fill="#e8b07a" opacity="0.8"/>
        <text x={235} y={186} textAnchor="middle" fontSize="7" fill="#7a2e00">fork</text>

        {/* Dog ring 3-4 */}
        <rect x={625} y={193} width={100} height={36} rx={4}
          fill="#7a2e00" opacity="0.85" stroke="#fdf4ec" strokeWidth="1.5"/>
        <text x={675} y={209} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fdf4ec">Dog Ring</text>
        <text x={675} y={220} textAnchor="middle" fontSize="7" fill="#fdf4ec">3rd–4th selector</text>
        {[196,204,212,220].map((y,i)=>(
          <g key={i}>
            <rect x={613} y={y} width={14} height={6} rx={1} fill="#e8b07a" stroke="#fdf4ec" strokeWidth="0.8"/>
            <rect x={725} y={y} width={14} height={6} rx={1} fill="#e8b07a" stroke="#fdf4ec" strokeWidth="0.8"/>
          </g>
        ))}
        <rect x={658} y={188} width={34} height={8} rx={2} fill="#e8b07a" opacity="0.8"/>
        <text x={675} y={186} textAnchor="middle" fontSize="7" fill="#7a2e00">fork</text>

        {/* ENGAGED state: dog ring 1-2 slid right to engage 2nd gear */}
        {/* Engagement teeth contact annotation */}
        <rect x={287} y={196} width={38} height={32} rx={3} fill="#c45a10" opacity="0.3" stroke="#c45a10" strokeWidth="1.5" strokeDasharray="3,2"/>
        <text x={306} y={180} textAnchor="middle" fontSize="8" fontWeight="700" fill="#c45a10">Dog teeth</text>
        <text x={306} y={191} textAnchor="middle" fontSize="8" fontWeight="700" fill="#c45a10">engaged →</text>
        <text x={306} y={237} textAnchor="middle" fontSize="8" fill="#c45a10">2nd gear locked</text>
        <text x={306} y={248} textAnchor="middle" fontSize="8" fill="#c45a10">to output shaft</text>

        {/* Neutral label (right ring) */}
        <text x={675} y={270} textAnchor="middle" fontSize="8.5" fill="#7a4a28" fontStyle="italic">Dog ring centred → neutral (neither 3rd nor 4th engaged)</text>

        {/* Ratio panel */}
        <rect x={10} y={285} width={880} height={28} rx={4} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={450} y={298} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">
          Gear ratios: 1st = 56/40 = 1.40 · 2nd = 44/30 = 1.47 · 3rd = 34/22 = 1.55 · 4th = 24/16 = 1.50
        </text>
        <text x={450} y={308} textAnchor="middle" fontSize="8" fill="#7a4a28">
          All gear pairs constantly meshed — dog clutch selects which output gear is locked to shaft · no sliding gear meshing required
        </text>
      </svg>
      <div style={S.dCaption}>In a constant-mesh gearbox every gear pair is always in mesh · dog clutches lock the selected ratio gear to its shaft · unselected gears freewheel silently</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 6 — Dog Clutch vs Friction Clutch Comparison
// ─────────────────────────────────────────────────────────────────────
function DiagramComparison() {
  const W = 900, H = 270;

  const props = [
    ['Torque transmission', 'Positive (form-fit) — zero slip', 'Friction (force-fit) — slip possible'],
    ['Engagement speed', 'Must match speeds first (or crash)', 'Can engage at any speed (smooth start)'],
    ['Shift feel', 'Abrupt, positive "clunk"', 'Smooth, gradual take-up'],
    ['Wear mechanism', 'Tooth impact only on shift event', 'Continuous friction wear on surfaces'],
    ['Heat generation', 'Negligible (no slip when locked)', 'High during slip / engagement'],
    ['Power loss locked', 'Near zero — rigid connection', 'Near zero (dry) — small (wet)'],
    ['Complexity', 'Simple, few parts', 'Pressure plate, diaphragm, friction disc'],
    ['Weight/size', 'Compact & light', 'Larger, heavier'],
    ['Max torque capacity', 'Very high (tooth strength limited)', 'Limited by friction area & clamp force'],
    ['Applications', 'Motorsport, motorcycles, marine', 'Passenger cars, light trucks, machinery'],
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Dog Clutch vs Friction Clutch — Direct Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header */}
        <rect x={10} y={10} width={880} height={26} rx={4} fill="#a04010"/>
        <text x={245} y={27} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">Property</text>
        <text x={545} y={27} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">Dog Clutch (Positive)</text>
        <text x={785} y={27} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">Friction Clutch</text>
        <line x1={470} y1={10} x2={470} y2={260} stroke="#fdf4ec" strokeWidth="1" opacity="0.4"/>
        <line x1={715} y1={10} x2={715} y2={260} stroke="#fdf4ec" strokeWidth="1" opacity="0.4"/>

        {props.map(([prop, dog, fric], i) => {
          const y = 42 + i * 22;
          const bg = i%2===0 ? '#fdf4ec' : '#fdf6ee';
          return (
            <g key={i}>
              <rect x={10} y={y-12} width={880} height={22} fill={bg} opacity="0.8"/>
              <text x={14} y={y+3} fontSize="8.5" fontWeight="700" fill="#7a2e00">{prop}</text>
              <text x={474} y={y+3} fontSize="8.5" fill="#a04010" fontFamily="'Courier New',monospace">{dog}</text>
              <text x={719} y={y+3} fontSize="8.5" fill="#7a4a28" fontFamily="'Courier New',monospace">{fric}</text>
            </g>
          );
        })}

        <rect x={10} y={250} width={880} height={14} rx={3} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={450} y={260} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">
          Dog clutch: best where no-slip, high-torque, fast shifting · Friction clutch: best where smooth engagement from rest or large speed difference is required
        </text>
      </svg>
      <div style={S.dCaption}>Dog clutches are binary (on/off) — friction clutches provide torque modulation · modern dual-clutch transmissions use automated friction clutches with dog-ring gear selection</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 7 — Forces & Torque Capacity
// ─────────────────────────────────────────────────────────────────────
function DiagramForces() {
  const W = 900, H = 290;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Dog Clutch — Torque Capacity, Engagement Forces &amp; Design Parameters</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arFR" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <marker id="arFRb" markerWidth="7" markerHeight="7" refX="2" refY="3.5" orient="auto">
            <polygon points="6 0,0 3.5,6 7" fill="#c45a10"/>
          </marker>
        </defs>

        {/* Left: dog ring in engagement showing forces */}
        {/* Shaft */}
        <rect x={30} y={125} width={280} height={22} rx={3} fill="#d4874a" opacity="0.6" stroke="#7a2e00" strokeWidth="2"/>

        {/* Dog ring side view */}
        <rect x={120} y={90} width={70} height={92} rx={5} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2.5"/>
        <text x={155} y={130} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fdf4ec">Dog</text>
        <text x={155} y={142} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fdf4ec">Ring</text>

        {/* Dog teeth engaging */}
        {[96, 108, 120, 132, 144, 156, 164, 172].map((y, i) => (
          <rect key={i} x={190} y={y} width={20} height={7} rx={1} fill="#7a2e00" stroke="#fdf4ec" strokeWidth="0.8"/>
        ))}

        {/* Gear hub face */}
        <rect x={210} y={82} width={50} height={108} rx={4} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="2"/>
        <text x={235} y={135} textAnchor="middle" fontSize="8" fill="#7a2e00">Gear</text>
        <text x={235} y={146} textAnchor="middle" fontSize="8" fill="#7a2e00">hub</text>
        {/* Mating recesses */}
        {[96, 108, 120, 132, 144, 156, 164, 172].map((y, i) => (
          <rect key={i} x={210} y={y} width={18} height={7} rx={1} fill="#c45a10" opacity="0.5" stroke="#7a2e00" strokeWidth="0.8"/>
        ))}

        {/* Tangential force arrow (torque transmission) */}
        <line x1={195} y1={115} x2={195} y2={85} stroke="#c45a10" strokeWidth="2.5" markerEnd="url(#arFR)"/>
        <text x={200} y={88} fontSize="9" fontWeight="700" fill="#c45a10">F_t</text>
        <text x={200} y={99} fontSize="8" fill="#a04010">(tangential</text>
        <text x={200} y={109} fontSize="8" fill="#a04010">force)</text>

        {/* Axial engagement force */}
        <line x1={100} y1={136} x2={120} y2={136} stroke="#7a2e00" strokeWidth="2.5" markerEnd="url(#arFR)"/>
        <text x={62} y={132} fontSize="8" fontWeight="700" fill="#7a2e00">F_axial</text>
        <text x={62} y={143} fontSize="8" fill="#7a4a28">(shift force)</text>

        {/* Radius annotation */}
        <line x1={30} y1={136} x2={155} y2={136} stroke="#e8b07a" strokeWidth="1" strokeDasharray="3,2"/>
        <line x1={155} y1={136} x2={155} y2={82} stroke="#e8b07a" strokeWidth="1" strokeDasharray="3,2"/>
        <text x={80} y={175} textAnchor="middle" fontSize="8" fill="#a04010">r_mean</text>

        {/* Torque formula */}
        <rect x={30} y={205} width={280} height={74} rx={5} fill="#fdf0e4" stroke="#c45a10"/>
        <text x={170} y={220} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Torque Capacity</text>
        <line x1={38} y1={225} x2={302} y2={225} stroke="#e8b07a"/>
        {[
          'T = n × F_t × r_mean',
          '  n = number of dogs',
          '  F_t = shear force per tooth',
          '  r_mean = pitch radius',
          'σ_shear = F_t / (h × b)',
          '  h = tooth height, b = width',
        ].map((l, i) => (
          <text key={i} x={38} y={238 + i * 12} fontSize="8.5" fontFamily="'Courier New',monospace" fill="#a04010">{l}</text>
        ))}

        {/* Right: Parameter table */}
        <rect x={340} y={15} width={545} height={265} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={612} y={33} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Key Design Parameters</text>
        <line x1={350} y1={39} x2={876} y2={39} stroke="#e8b07a"/>

        {[
          ['Number of dogs (n)', '6–12 typical · fewer = larger teeth = easier engagement window\nbut higher force per tooth on mis-shift'],
          ['Tooth height (h)', '5–15 mm depending on application\nLarger h = more overlap = more secure engagement'],
          ['Tooth width (b)', 'Governs shear area: σ = F_t/(h×b) ≤ σ_allow\nTypically b ≈ 0.6–1.2 × h'],
          ['Mean radius (r_mean)', 'Larger r → lower tooth force for same torque\nBut larger OD → heavier, more inertia'],
          ['Chamfer / lead angle', '30–45° chamfer aids engagement under speed mismatch\nReduces "window" slightly — trade-off with ease'],
          ['Material', 'Case-hardened steel (16MnCr5, 18CrNiMo7-6)\nSurface: 58–62 HRC · Core: tough to resist impact'],
          ['Backlash', '0.1–0.4 mm circumferential clearance\nAllows disengagement under load reversal'],
          ['Engagement speed', 'Δω < 50 rpm ideal for unsynchronised dogs\nSynchroniser cone: typically Δω < 1500 rpm OK'],
        ].map(([lbl, val], i) => (
          <g key={i}>
            <rect x={350} y={45+i*26} width={545} height={26}
              fill={i%2===0?'#fdf4ec':'#fdf6ee'}/>
            <text x={354} y={60+i*26} fontSize="8.5" fontWeight="700" fill="#7a2e00">{lbl}</text>
            {val.split('\n').map((vl, vi) => (
              <text key={vi} x={354} y={vi===0 ? 73+i*26 : 73+i*26} fontSize="8"
                fill="#a04010" fontFamily="'Courier New',monospace"
                dy={vi*10}>{vl}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Dog tooth shear stress governs static capacity · impact load at engagement governs fatigue life · chamfer angle trades engagement reliability against disengagement security</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 8 — Applications Across Industries
// ─────────────────────────────────────────────────────────────────────
function DiagramApplications() {
  const W = 900, H = 290;

  const apps = [
    { x: 75,  icon: '🔧', title: 'Lathe /\nMachine Tool', lines: ['Between-centres', 'turning precision', 'shafts & cylinders', 'Grinding ops', 'Indexing heads'] },
    { x: 235, icon: '🚗', title: 'Automotive\nGearbox', lines: ['Constant-mesh gear', 'selection (all gears)', 'Synchromesh for', 'smooth shifting', 'Sequential racing box'] },
    { x: 395, icon: '🏍', title: 'Motorcycle\nTransmission', lines: ['Direct dog engagement', 'Sequential shift drum', 'No synchromesh —', 'rider matches speed', 'Fast <50ms shifts'] },
    { x: 555, icon: '⚓', title: 'Marine /\nOutboard', lines: ['Forward/neutral/reverse', 'propeller drive', 'Engaged from rest', 'Clunk on selection', 'Simple & reliable'] },
    { x: 715, icon: '⚙️', title: 'Industrial\nMachinery', lines: ['PTO (power take-off)', 'Conveyors, winches', 'Machine tool', 'feeds/speeds', 'Torque limiters'] },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Drive Dog System Applications Across Engineering Disciplines</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {apps.map((a, i) => {
          const lines = a.title.split('\n');
          return (
            <g key={i}>
              <rect x={a.x-65} y={10} width={130} height={265} rx={6}
                fill={i%2===0?'#fdf4ec':'#fdf0e4'} stroke="#e8b07a" strokeWidth="1.5"/>
              {/* Icon circle */}
              <circle cx={a.x} cy={50} r={28} fill="#c45a10" opacity="0.85" stroke="#7a2e00" strokeWidth="2"/>
              <text x={a.x} y={56} textAnchor="middle" fontSize="20">{a.icon}</text>
              {/* Title */}
              {lines.map((l, li) => (
                <text key={li} x={a.x} y={90 + li*14} textAnchor="middle"
                  fontSize="10" fontWeight="700" fill="#7a2e00">{l}</text>
              ))}
              <line x1={a.x-55} y1={118} x2={a.x+55} y2={118} stroke="#e8b07a"/>
              {/* Detail lines */}
              {a.lines.map((l, li) => (
                <text key={li} x={a.x} y={132 + li * 16} textAnchor="middle"
                  fontSize="8.5" fill="#a04010">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Bottom bar */}
        <rect x={10} y={282} width={880} height={0} rx={3}/>
      </svg>
      <div style={S.dCaption}>Drive dog systems appear wherever positive, no-slip torque coupling is needed — from the precision demands of lathe between-centres turning to the millisecond shifts of motorsport gearboxes</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 9 — Failure Modes & Wear Bar Chart
// ─────────────────────────────────────────────────────────────────────
function DiagramFailure() {
  const W = 900, H = 250;

  const modes = [
    { label: 'Impact\nSpalling', sev: 4.2, x: 60,  desc: 'Mis-shift at high Δω\nchips tooth corners' },
    { label: 'Tooth\nShear', sev: 3.5, x: 195, desc: 'Overload fracture at\ntooth root' },
    { label: 'Fretting\nWear', sev: 2.8, x: 330, desc: 'Micro-motion in spline\nunder cyclic load' },
    { label: 'Dog\nScuffing', sev: 2.0, x: 465, desc: 'Adhesive wear on tooth\nflanks at high speed' },
    { label: 'Fatigue\nPitting', sev: 1.5, x: 600, desc: 'Contact fatigue on\ntooth flanks' },
    { label: 'Corrosion\n/ Rust', sev: 1.0, x: 735, desc: 'Surface oxidation\nincreases clearances' },
  ];

  const barBase = 175, maxH = 110, maxSev = 5, barW = 75;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Failure Modes — Relative Severity in Drive Dog Systems</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Axis */}
        <line x1={30} y1={60} x2={30} y2={barBase} stroke="#e8b07a" strokeWidth="1.5"/>
        <line x1={30} y1={barBase} x2={880} y2={barBase} stroke="#e8b07a" strokeWidth="1.5"/>
        {[0,1,2,3,4,5].map((v,i)=>{
          const y = barBase - (v/maxSev)*maxH;
          return (
            <g key={i}>
              <line x1={26} y1={y} x2={880} y2={y} stroke="#e8c89a" strokeWidth="0.7" strokeDasharray="3,3"/>
              <text x={24} y={y+4} textAnchor="end" fontSize="8" fill="#7a4a28">{v}</text>
            </g>
          );
        })}
        <text x={14} y={118} textAnchor="middle" fontSize="9" fill="#7a2e00" transform="rotate(-90,14,118)">Severity</text>

        {modes.map((m, i) => {
          const h = (m.sev / maxSev) * maxH;
          const lines = m.label.split('\n');
          const dLines = m.desc.split('\n');
          return (
            <g key={i}>
              <rect x={m.x} y={barBase-h} width={barW} height={h}
                fill="#c45a10" opacity={0.55 + i*0.06} rx={3}/>
              <text x={m.x+barW/2} y={barBase-h-6} textAnchor="middle"
                fontSize="10" fontWeight="700" fill="#7a2e00">{m.sev}</text>
              {lines.map((l, li) => (
                <text key={li} x={m.x+barW/2} y={barBase+14+li*13}
                  textAnchor="middle" fontSize="8.5" fill="#7a4a28">{l}</text>
              ))}
              {dLines.map((l, li) => (
                <text key={li} x={m.x+barW/2} y={barBase+44+li*11}
                  textAnchor="middle" fontSize="7.5" fill="#a04010">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Banner */}
        <rect x={30} y={8} width={860} height={26} rx={4} fill="#fdf0e4" stroke="#c45a10"/>
        <text x={460} y={20} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#7a2e00">
          Primary cause of dog failure: high-speed mis-shifts without speed synchronisation — impacts chip tooth chamfers and corners
        </text>
        <text x={460} y={30} textAnchor="middle" fontSize="8.5" fill="#a04010">
          Prevention: synchromesh, driver technique (quick shifts), correct oil, case-hardened material, regular inspection
        </text>
      </svg>
      <div style={S.dCaption}>Impact spalling is the most common failure mode in unsynchronised dog boxes — chamfered tooth profiles and quick-shift technique dramatically reduce incident rates</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// MAIN EXPORT
// ─────────────────────────────────────────────────────────────────────
export default function DriveDogs() {
  return (
    <div style={S.wrapper}>

      <h1 style={S.h1}>Drive Dog Systems in Mechanical Engineering</h1>
      <p style={S.p}>
        A <strong>drive dog</strong> is a mechanical coupling device that transmits torque by direct physical engagement — a
        projecting lug, tooth, or tail locks against a mating recess, slot, or pin rather than relying on friction.
        The term covers two distinct but related families: <em>lathe dogs (carriers)</em>, which clamp a workpiece to
        drive it during between-centres turning, and <em>dog clutches (positive clutches)</em>, which couple or decouple
        rotating shafts by axial engagement of interlocking teeth. Both operate on the same principle — positive, zero-slip
        mechanical interlock — making them indispensable wherever precise, reliable torque transmission is required.
      </p>

      <InfoBox title="Quick Reference — Core Concepts" items={[
        "Drive dog principle: positive form-fit engagement — torque transmitted by tooth/lug contact, never by friction",
        "Lathe dog: clamps onto workpiece; tail engages drive plate pin or slot; workpiece driven between centres with both ends supported",
        "Dog clutch: axially sliding dog ring with rectangular or chamfered teeth engages matching teeth on target gear/shaft",
        "Key advantage over friction coupling: zero slip when engaged, very high torque capacity, negligible heat generation",
        "Key disadvantage: abrupt engagement requires speed synchronisation — crash engagement at high Δω causes tooth damage",
        "Synchromesh: friction cone pre-equalises shaft and gear speeds before dog teeth are allowed to engage",
        "Torque capacity: T = n × F_t × r_mean  (n = tooth count, F_t = tangential force, r_mean = pitch radius)",
        "Material: case-hardened alloy steel (58–62 HRC surface, tough core) to withstand impact loading on each shift",
      ]}/>

      <h2 style={S.h2}>Lathe Dog System — Between-Centres Setup</h2>
      <p style={S.p}>
        When turning long shafts or components requiring high concentricity, a lathe dog (carrier) enables the workpiece
        to be driven from the headstock spindle while being supported between a live centre and a dead (tailstock) centre.
        The centres provide pure axial location; all torque is transmitted through the dog, leaving both support points
        contact-load-free and perfectly aligned.
      </p>
      <DiagramLatheSetup />
      <Table2 rows={[
        ["Purpose of between-centres","Both ends supported on centres → highest geometric accuracy and concentricity\nWork can be removed and re-mounted returning to exactly the same axis\nEssential for crankshafts, axles, spindles requiring multi-operation turning"],
        ["Drive plate (faceplate)","Mounted directly on headstock spindle nose — rotates at spindle speed\nCarries one or more drive pins (studs) or slots to engage dog tail\nSimple hardened steel disc, sometimes with counterbalance holes"],
        ["Live vs dead centre","Live centre: rotates with workpiece in headstock (no friction)\nDead centre: fixed in tailstock — workpiece rotates on it (needs lubrication)\nHalf-dead centre: flat ground away to allow facing operations at tailstock end"],
        ["Set-screw selection","Standard set-screw: protrudes above dog body — snag hazard at speed\nHeadless (cup-point) set-screw: flush with body — safer, preferred practice\nMultiple screws on large dogs (> 80 mm) for balanced clamping force"],
        ["Counterbalancing","Eccentric dog mass causes vibration and run-out, especially at high speeds\nFix: add counterbalance weight opposite the tail, or reduce spindle speed\nDouble-tail (forked) dogs provide inherent balance — preferred for precision work"],
        ["Cylindrical grinding use","Lathe dogs also drive workpieces on cylindrical grinding machines\nExactly the same principle — centres provide datum, dog drives the rotation\nAllows grinding to tight cylindricity tolerances (< 2 µm) on long shafts"],
      ]}/>

      <h2 style={S.h2}>Lathe Dog Types</h2>
      <DiagramDogTypes />
      <Table2 rows={[
        ["Straight-tail dog","Tail extends radially outward from dog body (parallel to workpiece axis)\nRequires at least one drive stud on faceplate to catch the tail\nNo tendency to crowd workpiece off-centre — preferred for precision turning\nAvailable in round-bore (single screw) or clamp (two screw) versions"],
        ["Bent-tail dog","Tail bent 90° — hooks directly into a faceplate slot or over a chuck jaw\nMore versatile (works with plain faceplate or chuck) — popular for quick setups\nRisk: if tail wedges in a closed-end slot under cutting force, it can lever workpiece sideways\nMitigation: ensure clearance at tail end; use open-ended slots on faceplate"],
        ["Clamp dog","Two-piece body secured by two cap screws across a clamping gap\nAccommodates square, hexagonal, flat, keyway, or irregular cross-sections\nSlower to set up than screw types but universal — no need for V-groove match\nSingle jaw version also available for quick rough operations"],
        ["Size selection","Dog capacity (max bore) must exceed workpiece diameter\nCommon sizes: 6–100 mm bore for bench lathes; up to 300+ mm for large centre lathes\nOversize dog causes imbalance; undersize prevents secure clamping\nRule of thumb: use the smallest dog that comfortably fits the workpiece"],
        ["Standard sizes","DIN 1235 / ISO standards specify bore range, body dimensions, screw positions\nMetric set-screw sizes (M5–M16) matched to expected torque capacity\nSquare-head screws traditional; hex socket (Allen) preferred for compact access"],
      ]}/>

      <h2 style={S.h2}>Dog Clutch — Anatomy &amp; Tooth Profiles</h2>
      <p style={S.p}>
        A dog clutch couples two co-axial rotating members by axial sliding of a splined dog ring whose teeth mesh with
        matching recesses on the target gear hub. The spline on the shaft allows the ring to slide axially while remaining
        rotationally locked — so engaging the dog instantly and positively couples the gear to the shaft.
      </p>
      <DiagramDogClutchAnatomy />
      <Table2 rows={[
        ["Dog ring (sliding sleeve)","Splined internally to slide on shaft splines — rotates with shaft at all times\nExternal or face teeth engage mating recesses on target gear hub\nShift fork locates in circumferential groove; fork moved by selector rod/drum"],
        ["Rectangular (square) teeth","Full-depth square profile — maximum shear area, highest torque capacity\nNo chamfer → requires close speed match for engagement (Δω < 30–100 rpm ideal)\nUsed in: motorsport gearboxes, racing motorcycles, marine propeller drives"],
        ["Chamfered / trapezoidal teeth","Lead-in chamfer (30–45°) on tooth tip guides engagement under small speed mismatch\nChamfer reduces effective tooth overlap slightly — lower disengagement security\nUsed in: road car gearboxes (with synchromesh), agricultural machinery"],
        ["Pent-roof profile","Roof-shaped tooth tip — self-centering and minimal wear on aborted shifts\nPopular in high-end motorsport (Albins, Hewland) — tolerates imperfect shifts\nDifficult to manufacture — requires CNC grinding"],
        ["Number of teeth (dogs)","6 dogs: large windows, easy engagement but high per-tooth impact load\n12 dogs: smaller windows but impact load shared — higher fatigue life\nRacing: 6–8 teeth (prioritise fast engagement); road: 10–16 teeth (prioritise life)"],
        ["Spline interface","Internal splines on dog ring match external splines on shaft (ANSI/ISO 4156)\nStraight-sided splines: common for light duty · involute splines: stronger, self-centring\nAxial sliding must be free (no burrs, adequate oil) — stiff splines prevent disengagement"],
      ]}/>

      <h2 style={S.h2}>Synchromesh Engagement Sequence</h2>
      <p style={S.p}>
        In passenger vehicles, the harsh engagement of an unsynchronised dog clutch is unacceptable for normal driving.
        The Borg-Warner synchromesh system (developed in the 1920s, standardised by the 1950s) interposes a friction cone
        between the sliding sleeve and the target gear. The cone synchronises the speeds before the dog teeth are permitted
        to engage, producing smooth, quiet gear changes.
      </p>
      <DiagramSynchromesh />
      <Table2 rows={[
        ["Blocker ring (baulk ring)","Prevents premature dog engagement while speeds differ\nBlocker teeth are slightly offset — while the cone drags, the offset holds the blocker engaged\nOnce speeds match, no drag → blocker rotates free → dog teeth pass through"],
        ["Synchroniser cone","Tapered friction surface (brass or molybdenum-coated) on target gear\nCone half-angle typically 6.5–7.5° — too shallow → self-locking; too steep → inefficient\nGrooves in cone face expel oil during engagement (anti-aquaplane)"],
        ["Synchro capacity","T_sync = μ × F_axial × r_cone / sin(α)  — governs synchronisation time\nTime to sync: t ≈ J_input × Δω / T_sync  (J = mass moment of inertia)\nMultiple-cone synchronisers (2–4 cones in series) for large/heavy shafts"],
        ["Double & triple cone synchro","Additional cones increase total friction area → faster synchronisation\nUsed on 1st and 2nd gears where inertia difference is greatest\nCommon in diesel trucks, heavy commercial vehicles"],
        ["Direct-acting vs servo","Direct-acting: driver force directly operates the shift (most manual gearboxes)\nServo-synchroniser: spring-loaded indexing pawls amplify initial force during pre-synchro\nElectronic synchro: ECU-controlled motor adjusts engine speed (AMT, dual-clutch)"],
        ["Shift technique","Passenger car: slow the gear lever — synchromesh does the work\nDog box (motorsport): FAST shift — spend as little time on neutral as possible\nDouble-declutching: heel-and-toe technique to match revs for unsynchronised downshifts"],
      ]}/>

      <h2 style={S.h2}>Dog Clutch in a Constant-Mesh Gearbox</h2>
      <p style={S.p}>
        Modern manual gearboxes use constant-mesh helical gears rather than sliding spur gears. All gear pairs are
        permanently in mesh; dog clutches select which output gear is rotationally locked to the output shaft.
        This arrangement allows helical gears (quieter, stronger) and places all gear-selection load on the robust dog teeth
        rather than on the gear flanks themselves.
      </p>
      <DiagramGearbox />
      <Table2 rows={[
        ["Constant-mesh advantage","Gears never slide in/out of mesh → helical profiles possible → quiet operation\nNo gear-clash on selection — only dog teeth engage, not gear teeth\nAll gears always spinning → minimal shock when dog engages (if synced)"],
        ["Freewheeling gears","Gears on output shaft run on needle roller bearings — freewheel silently unless dog engaged\nInput shaft gears fixed (pressed/splined) — always rotate with input\nThis arrangement allows the same gear to be selected by sliding the dog ring either direction"],
        ["Selector fork & rod","Shift fork fits groove in dog ring outer face; fork sits on selector rod\nH-gate: multiple rods, each controlling one dog ring; interlock prevents two gears at once\nSequential: single rotating drum; drum cam profiles move each fork in sequence"],
        ["Neutral position","Dog ring centred between two gears — teeth of ring clear of both hubs\nOutput shaft freewheels — no drive transmitted\nAll input gears still spinning (driven by engine through input shaft)"],
        ["Reverse gear","Typically a separate idler (spur) gear slid into mesh — not constant-mesh in most designs\nSpur cut (straight teeth) to allow sliding engagement; characteristic reverse whine\nPremium gearboxes: constant-mesh reverse with its own synchromesh and dog ring"],
      ]}/>

      <h2 style={S.h2}>Dog Clutch vs Friction Clutch</h2>
      <DiagramComparison />

      <h2 style={S.h2}>Forces, Torque Capacity &amp; Design Parameters</h2>
      <DiagramForces />
      <Table2 rows={[
        ["Torque capacity formula","T = n × σ_allow × A_tooth × r_mean\nA_tooth = h × b (height × face width of one tooth)\nn = number of engaged dogs\nσ_allow for case-hardened steel in shear ≈ 400–600 MPa"],
        ["Impact load at engagement","F_impact = J_input × Δω / Δt  (impulsive force during engagement transient)\nSmall Δω and fast engagement (small Δt) both reduce peak impact\nDesign criterion: F_impact × safety factor ≤ tooth fracture load"],
        ["Self-disengagement","Helical spline (helix angle 15–25°) converts torque to axial force to keep dogs engaged\nStraight spline: dog ring must be held by shift fork or detent throughout engagement\nDetent ball-and-groove in shift mechanism prevents accidental neutral jump"],
        ["Dog ring inertia","Low inertia desirable — ring must accelerate/decelerate easily during sync\nThin wall, small radius preferred; aluminium rings for racing (lower inertia, less durable)\nSteel rings: heavier but much longer life — used in production vehicles"],
        ["Surface treatment","Case carburising (0.8–1.2 mm case depth) for teeth — core remains tough\nShot peening introduces compressive residual stress — improves fatigue life 20–40%\nNitrocarburising: alternative for smaller dogs — lower distortion than case-hardening"],
        ["Lubrication","Gearbox oil (GL-4 or GL-5, 75W-90) lubricates spline interface and dog faces\nOil film on tooth faces cushions initial impact — critical for long life\nRacing: low-viscosity oil (0W-20) for minimum drag — shorter dog life acceptable"],
      ]}/>

      <h2 style={S.h2}>Applications</h2>
      <DiagramApplications />
      <Table2 rows={[
        ["Lathe turning between centres","Precision shaft turning: crankshafts, spindles, lead-screws, hydraulic rams\nCylindrical grinding: maintains sub-micron axis repeatability across operations\nThread chasing, taper turning — all operations requiring repeated repositioning to same axis"],
        ["Automotive manual gearbox","All synchromesh passenger car gearboxes use dog rings for gear selection\n4–8 dog rings in a 6-speed gearbox; each ring selects two adjacent gears\nDual-clutch transmission (DCT): dog rings pre-select next gear while current is engaged"],
        ["Motorsport / racing","Straight-cut constant-mesh gears with unsynchronised dog rings\nSequential shift drum — push/pull lever for up/down shift in <80 ms\nFlatshift: ignition cut during upshift allows shifting without releasing throttle"],
        ["Motorcycle transmission","Sequential constant-mesh gearbox; dogs engage directly without synchromesh\nRider blips throttle on downshift (or uses quick-shifter ECU cut on upshift)\nSelector drum rotated by ratchet mechanism on shift lever"],
        ["Marine drives","Inboard engine: dog clutch selects forward/neutral/reverse to propeller shaft\nEngaged from rest — no synchromesh needed for low-inertia marine propellers\nAuditble 'clunk' on engagement is characteristic of dog-type marine gearboxes"],
        ["Power take-off (PTO)","Agricultural/industrial machines: dog clutch engages driven implements from engine\nTractor PTO: 540 or 1000 rpm standardised shafts engaged by dog clutch lever\nSelf-propelled machinery: dogs engage/disengage individual driven axles or implements"],
        ["Machine tool feed drives","Lathe feed gearboxes: multiple dog clutches select thread pitches or feed rates\nDrilling machine: dog clutch engages/disengages power downfeed\nGear-hobbing machines, broaches: precision index dogs prevent rotational slip"],
      ]}/>

      <h2 style={S.h2}>Failure Modes, Inspection &amp; Maintenance</h2>
      <DiagramFailure />
      <Table2 rows={[
        ["Impact spalling","Most common mode — mis-shift at high Δω chips tooth corner chamfers\nChips circulate in oil, accelerate abrasive wear on all components\nPrevention: synchromesh, driver technique, RPM-matching on downshifts"],
        ["Tooth shear (overload fracture)","Single-event fracture when transmitted torque exceeds tooth shear strength\nCaused by: missed gear, wheel spin-grip recovery, severe impact load\nDesign remedy: increase n (more teeth), increase h and b, upgrade material grade"],
        ["Fretting wear in splines","Micro-oscillation between dog ring bore and shaft spline under cyclic load\nResults in spline flank wear, loosening, and fretting debris (reddish oxide)\nPrevention: correct oil grade, avoid undersized/worn splines, check clearance regularly"],
        ["Lathe dog crowding","Bent-tail dog wedges in closed-end slot → workpiece levered off axis\nResult: taper cut, chatter, dimensional error\nPrevention: check tail–slot clearance; use open-ended driving slots on faceplate"],
        ["Setscrew damage to workpiece","Set-screw marks (witness marks) left on workpiece finish surface\nUse copper pad under screw tip, or position dog on non-critical diameter portion\nHeadless screws minimise snag hazard but still leave witness mark"],
        ["Inspection checklist","Check tooth chamfers for chipping — replace if >30% of chamfer gone\nCheck spline flanks for fretting — measure clearance; replace if > 0.5 mm slack\nInspect dog ring groove for shift fork wear — groove widens over time → imprecise shift\nCheck oil for metallic debris — magnetic sump plug captures steel particles"],
        ["Lathe dog safety","Rotating dog + projecting tail = serious entanglement hazard\nAlways use headless set screws (no protruding head)\nMaintain safe distance — use thread shield or enclosure at high speeds\nNever reach past rotating dog setup — stop machine before adjusting"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Torque capacity: T = n × F_t × r_mean  where n = number of dogs, F_t = force per tooth, r_mean = mean radius",
        "Tooth shear stress: τ = F_t / (h × b)  (h = tooth height, b = tooth face width)  ·  must be ≤ τ_allow",
        "Impact force: F_impact ≈ (J × Δω) / Δt  — minimised by speed-matching and fast engagement",
        "Synchromesh torque: T_sync = μ × F_axial × r_cone / sin(α)  (α = cone half-angle, μ ≈ 0.06–0.12)",
        "Synchronisation time: t ≈ J_input × Δω / T_sync  — shorter with more cone friction area or lower inertia",
        "Dog engagement window: angular window W = 360° / (n × tooth_pitch_ratio) — fewer teeth = bigger window",
        "Chamfer lead-in angle: 30–45° typical · too steep = difficult to engage · too shallow = no chamfer benefit",
        "Spline clearance check: circumferential backlash < 0.2 mm (new) · replace when > 0.5 mm",
        "Between-centres concentricity: typical accuracy 2–5 µm TIR on precision centre lathe",
        "Lathe dog counterbalance: m_counterbalance × r_cb = m_dog × r_dog  (moments about spindle axis)",
      ]}/>

    </div>
  );
}